import { render } from "./index.vue?vue&type=template&id=17d4f164&scoped=true&lang=html"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=17d4f164&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d4f164"],['__file',"src/views/Home/Components/MarketingNotice/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17d4f164"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17d4f164', __exports__)) {
    api.reload('17d4f164', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=17d4f164&scoped=true&lang=html", () => {
    api.rerender('17d4f164', render)
  })

}


export default __exports__